import { BuscaInscricao, insereInscricao } from '../../services/inscricao';
import calculateValorTotal from '../calcPrime';
import { removeDescontoAdesaoFinados2023 } from './finados2023';

export const atualizarAdesao = async (inscricao, associado, totalDependentes, valorServicosAdicionais,dadosAssociado) => {
    const buscaInscricaoCadastrada = await BuscaInscricao(inscricao);

    await removeDescontoAdesaoFinados2023(dadosAssociado);

    if (
        (buscaInscricaoCadastrada &&
            associado.SubGrupo.trim().substring(0, 3) === 'ZPC') ||
        (buscaInscricaoCadastrada && associado.SubGrupo.trim() === 'ZI')
    ) {
        const { valorTotalSomaDependente } = calculateValorTotal(
            associado,
            totalDependentes,
            valorServicosAdicionais
        );

        const dados = {
            Pagamento: null,
            tipoPagamento: null,
            Valor: valorTotalSomaDependente,
            Inscricao: inscricao,
            valorPago: null
        };

        return await insereInscricao(dados);
    }
};
